<div
  appClickOutside
  appClickOutsideFocusOut
  (clickOutside)="closeFilterDropdown($event === 'escape')"
>
  <button
    #filterToggleButton
    type="button"
    [ngClass]="toggleClasses()"
    (click)="onFilterClick()"
    data-testid="accounts-filter"
    aria-haspopup="dialog"
    [attr.aria-expanded]="showFilterDropdown"
    [attr.aria-label]="'filterAccounts' | i18n"
    [attr.title]="'filterAccounts' | i18n"
    aria-controls="accounts-filter-panel"
  >
    <span
      class="tw-absolute tw-right-1 tw-top-1 tw-flex tw-min-w-[18px] tw-items-center tw-justify-center tw-rounded-full tw-bg-color-text-default tw-px-1 tw-py-[2px] tw-text-[10px] tw-font-semibold tw-leading-none tw-text-color-surface-page"
      *ngIf="isFiltered() && !inline()"
    >
      {{ filterCount() }}
    </span>
    <!-- On the round button a dot says something is hidden; the panel and the bar say what. -->
    <span
      class="tw-pointer-events-none tw-absolute tw-right-[9px] tw-top-[9px] tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-custom-teal-9"
      *ngIf="isFiltered() && inline()"
      data-testid="accounts-filter-dot"
    ></span>
    <icon name="filter-manage" [size]="inline() ? 5 : 4"></icon>
  </button>

  <button
    *ngIf="showFilterDropdown"
    type="button"
    class="tw-hidden sm:tw-fixed sm:tw-inset-0 sm:tw-z-40 sm:tw-block sm:tw-bg-black/40"
    (click)="closeFilterDropdown()"
    aria-label="Close filter menu"
  ></button>

  <!-- The Accounts page's popover: under the button, its right edge on the button's (left-0 is the
       fallback; alignUnderButton() sets the real offset and keeps it inside the row); a bottom
       sheet on phones. -->
  <div
    *ngIf="showFilterDropdown && inline()"
    #filterPanel
    id="accounts-filter-panel"
    role="dialog"
    aria-label="Account filters"
    tabindex="-1"
    data-testid="accounts-filter-popover"
    appGlossScroll
    class="tw-absolute tw-left-0 tw-top-full tw-z-30 tw-mt-2 tw-w-[320px] tw-max-w-full tw-select-none tw-rounded-[20px] tw-bg-color-surface-elevated tw-p-2 tw-shadow-elevation-card focus:tw-outline-none sm:tw-fixed sm:tw-inset-x-0 sm:tw-bottom-0 sm:tw-left-0 sm:tw-top-auto sm:tw-z-50 sm:tw-mt-0 sm:tw-flex sm:tw-max-h-[88vh] sm:tw-w-full sm:tw-max-w-none sm:tw-flex-col sm:tw-overflow-auto sm:tw-rounded-b-none sm:tw-rounded-t-[28px] sm:tw-px-4 sm:tw-pb-[calc(24px+env(safe-area-inset-bottom,0px))] sm:tw-shadow-2xl"
  >
    <div
      class="tw-hidden sm:tw-mx-auto sm:tw-mb-2 sm:tw-mt-0.5 sm:tw-block sm:tw-h-1 sm:tw-w-9 sm:tw-rounded-sm sm:tw-bg-color-border-subtle"
      aria-hidden="true"
    ></div>
    <div
      class="tw-flex tw-h-10 tw-items-center tw-justify-between tw-gap-2 tw-px-3 tw-pb-1 tw-pt-1.5 sm:tw-px-2"
    >
      <b class="tw-text-[15px] tw-font-semibold tw-text-color-text-default sm:tw-text-[17px]">{{
        "filterAccounts" | i18n
      }}</b>
      @if (isFiltered()) {
        <button
          type="button"
          class="tw--mr-2 tw-rounded-lg tw-px-2 tw-py-1 tw-text-[13px] tw-font-semibold tw-text-color-text-action hover:tw-bg-color-surface-selected"
          data-testid="accounts-filter-reset"
          (click)="onResetClick()"
        >
          {{ "filterReset" | i18n }}
        </button>
      } @else if (shownCount() !== null && totalCount() !== null) {
        <span
          class="tw-text-xs tw-font-medium tw-text-color-text-tertiary"
          data-testid="accounts-filter-shown"
          >{{ "filterShownOfTotal" | i18n: shownCount() : totalCount() }}</span
        >
      }
    </div>

    <ng-container [ngTemplateOutlet]="inlineSections"></ng-container>

    <!-- Phones: the sheet closes on the number of accounts it leaves showing. -->
    <div class="tw-hidden sm:tw-block sm:tw-pt-3.5">
      <button
        type="button"
        class="tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-custom-teal-11 tw-text-sm tw-font-semibold tw-text-white tw-shadow-elevation-cta-glow"
        data-testid="accounts-filter-done"
        (click)="closeFilterDropdown()"
      >
        {{ "filterShowN" | i18n: showLabelCount() }}
      </button>
    </div>
  </div>

  <div
    *ngIf="showFilterDropdown && !inline()"
    #filterPanel
    id="accounts-filter-panel"
    role="dialog"
    aria-label="Account filters"
    tabindex="-1"
    class="border-gradient-neuomorphic shadow-subtle-minimal tw-absolute tw-left-0 tw-top-full tw-z-10 tw-inline-block tw-select-none tw-rounded-2xl tw-bg-dt-surface-elevated tw-w-[320px] tw-max-w-full sm:tw-fixed sm:tw-inset-x-0 sm:tw-bottom-0 sm:tw-top-auto sm:tw-left-0 sm:tw-z-[60] sm:tw-flex sm:tw-flex-col sm:tw-w-full sm:tw-h-[min(80vh,calc(100vh-16px))] sm:tw-rounded-b-none sm:tw-rounded-t-[28px] sm:tw-shadow-2xl sm:tw-pb-[var(--safe-area-bottom,0px)] sm:before:tw-hidden"
  >
    <div
      class="tw-hidden sm:tw-relative sm:tw-sticky sm:tw-top-0 sm:tw-z-[1] sm:tw-flex sm:tw-min-h-12 sm:tw-items-center sm:tw-justify-center sm:tw-rounded-t-[28px] sm:tw-bg-color-surface-card sm:tw-px-4 sm:tw-pb-3 sm:tw-pt-2"
    >
      <button
        type="button"
        class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full sm:tw-absolute sm:tw-left-1/2 sm:tw-top-1 sm:tw--translate-x-1/2"
        (click)="closeFilterDropdown()"
        aria-label="Close filter menu"
      >
        <svg class="tw-text-color-text-action">
          <use [attr.xlink:href]="'images/sprite.svg#down-arrow-primary'" />
        </svg>
      </button>
    </div>

    <div
      appGlossScroll
      class="tw-flex tw-flex-col tw-gap-[10px] tw-p-4 sm:tw-flex-1 sm:tw-overflow-y-auto"
    >
      <ng-container [ngTemplateOutlet]="filterSections"></ng-container>
    </div>
  </div>
</div>

<!-- The Accounts page's rows: a checkbox, the option and how many accounts it covers. A zero-count
     option stays in the list, locked, as the stand-alone panel does. -->
<ng-template #inlineSections>
  <div
    class="tw-px-3 tw-pb-1 tw-pt-2.5 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary sm:tw-px-2 sm:tw-pt-3"
  >
    {{ "filterGroupManual" | i18n }}
  </div>
  @for (row of manualRows(); track row.type) {
    <div
      class="tw-flex tw-h-10 tw-items-center tw-gap-2.5 tw-rounded-[10px] tw-px-3 sm:tw-h-12 sm:tw-rounded-xl sm:tw-px-2"
      [ngClass]="
        row.disabled
          ? 'tw-cursor-not-allowed tw-opacity-50'
          : 'tw-cursor-pointer hover:tw-bg-color-surface-card'
      "
      data-testid="accounts-filter-row"
      (click)="onManualRowClick($event, row.type, row.checked)"
    >
      <app-checkbox
        class="tw-min-w-0 tw-flex-1 [&>div]:tw-gap-3"
        [checked]="row.checked"
        [disabled]="row.disabled"
        [title]="row.labelKey ? (row.labelKey | i18n) : row.fallbackLabel"
        [customisedBoxSize]="'6'"
        (onChange)="onManualTypeFilterChange(row.type, $event)"
      ></app-checkbox>
      <span
        class="tw-shrink-0 tw-text-xs tw-font-medium tw-tabular-nums tw-text-color-text-tertiary"
        data-testid="accounts-filter-count"
        >{{ row.count }}</span
      >
    </div>
  }

  @if (syncedRows().length > 0) {
    <div
      class="tw-px-3 tw-pb-1 tw-pt-2.5 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.06em] tw-text-color-text-secondary sm:tw-px-2 sm:tw-pt-3"
    >
      {{ "filterGroupFetched" | i18n }}
    </div>
  }
  @for (row of syncedRows(); track row.origin) {
    <div
      class="tw-flex tw-h-10 tw-items-center tw-gap-2.5 tw-rounded-[10px] tw-px-3 sm:tw-h-12 sm:tw-rounded-xl sm:tw-px-2"
      [ngClass]="
        row.disabled
          ? 'tw-cursor-not-allowed tw-opacity-50'
          : 'tw-cursor-pointer hover:tw-bg-color-surface-card'
      "
      data-testid="accounts-filter-row"
      (click)="onSyncedRowClick($event, row.origin, row.checked)"
    >
      <app-checkbox
        class="tw-min-w-0 tw-flex-1 [&>div]:tw-gap-3"
        [checked]="row.checked"
        [disabled]="row.disabled"
        [title]="row.label"
        [customisedBoxSize]="'6'"
        (onChange)="onSyncedOriginFilterChange(row.origin, $event)"
      ></app-checkbox>
      <span
        class="tw-shrink-0 tw-text-xs tw-font-medium tw-tabular-nums tw-text-color-text-tertiary"
        data-testid="accounts-filter-count"
        >{{ row.count }}</span
      >
    </div>
  }
</ng-template>

<ng-template #filterSections>
  <!-- Manual Section -->
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div
      class="tw-text-sm tw-font-semibold tw-leading-5 tw-tracking-[0.7px] tw-text-color-text-secondary tw-uppercase"
    >
      Manual
    </div>
    <div
      class="tw-box-border tw-flex tw-min-h-[58px] tw-w-full tw-items-stretch tw-rounded-2xl"
      [ngClass]="{
        'tw-bg-dt-surface-today-tertiary':
          selectedFilter()?.manual?.[type] && !isManualTypeDisabled(type),
        'tw-bg-color-surface-hover sm:tw-bg-color-surface-sunken dark:tw-bg-color-surface-sunken':
          !selectedFilter()?.manual?.[type] || isManualTypeDisabled(type),
        'tw-cursor-not-allowed': isManualTypeDisabled(type),
      }"
      *ngFor="let type of manualAccountTypes()"
    >
      <app-checkbox
        [checked]="selectedFilter()?.manual?.[type] && !isManualTypeDisabled(type)"
        [disabled]="isManualTypeDisabled(type)"
        (onChange)="onManualTypeFilterChange(type, $event)"
        [title]="manualTypeLabel(type)"
        [customisedBoxSize]="'6'"
        class="tw-flex tw-w-full [&>div]:tw-w-full [&>div]:tw-items-center [&>div]:tw-gap-4 [&>div]:tw-rounded-2xl [&>div]:tw-p-4"
        [class.tw-cursor-pointer]="!isManualTypeDisabled(type)"
      ></app-checkbox>
    </div>
  </div>

  <!-- Synced Section -->
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div
      class="tw-text-sm tw-font-semibold tw-leading-5 tw-tracking-[0.7px] tw-text-color-text-secondary tw-uppercase"
    >
      {{ "autoFetch" | i18n }}
    </div>
    <ng-container *ngFor="let origin of displayedSyncedOrigins()">
      <div
        class="tw-box-border tw-flex tw-min-h-[58px] tw-w-full tw-items-stretch tw-rounded-2xl"
        [ngClass]="{
          'tw-bg-dt-surface-today-tertiary':
            selectedFilter()?.synced?.[origin] && !isSyncedOriginDisabled(origin),
          'tw-bg-color-surface-hover sm:tw-bg-color-surface-sunken dark:tw-bg-color-surface-sunken':
            !selectedFilter()?.synced?.[origin] || isSyncedOriginDisabled(origin),
          'tw-cursor-not-allowed': isSyncedOriginDisabled(origin),
        }"
      >
        <app-checkbox
          [checked]="selectedFilter()?.synced?.[origin] && !isSyncedOriginDisabled(origin)"
          [disabled]="isSyncedOriginDisabled(origin)"
          (onChange)="onSyncedOriginFilterChange(origin, $event)"
          [title]="syncedOriginLabel(origin)"
          [customisedBoxSize]="'6'"
          class="tw-flex tw-w-full [&>div]:tw-w-full [&>div]:tw-items-center [&>div]:tw-gap-4 [&>div]:tw-rounded-2xl [&>div]:tw-p-4"
          [class.tw-cursor-pointer]="!isSyncedOriginDisabled(origin)"
        ></app-checkbox>
      </div>
    </ng-container>
  </div>
</ng-template>
